export default {
  methods: {
    deleteReview: function (id) {
      this.$axios
        .delete("/review", {
          data: {
            review_id: id,
          },
        })
        .then(() => {
          // Global event
          this.$root.$emit("delete-review", id);

          this.$store.commit("showSnackbar", {
            text: "Review Deleted",
          });
        })
        .catch(() => {
          this.$store.commit("showSnackbar", {
            text: "Delete Failed",
            error: true,
          });
        });
    },
  },
};
